"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialize = exports.assertIsInitialized = exports.isInitialized = void 0;
var statusHelpers_1 = require("./statusHelpers");
Object.defineProperty(exports, "isInitialized", { enumerable: true, get: function () { return statusHelpers_1.isInitialized; } });
Object.defineProperty(exports, "assertIsInitialized", { enumerable: true, get: function () { return statusHelpers_1.assertIsInitialized; } });
Object.defineProperty(exports, "initialize", { enumerable: true, get: function () { return statusHelpers_1.initialize; } });
